import { Icon } from 'Components';
import NewFooter from '../Components/NewFooter';
import PortalButton from '../Components/PortalButton';
import styles from './Layout.module.scss';
import Logo from '../Components/Logo/Logo';

interface LayoutProps {
	children: React.ReactNode;
	showPortalBtn?: boolean;
	showRightLayout?: boolean;
}

const content = {
	heading: 'Know your risks. Defend your data.',
	description: 'Empower next-level data security with the Venza System.'
};

export default function NewAuthLayout({
	children,
	showPortalBtn = false,
	showRightLayout = true
}: LayoutProps) {
	return (
		<div className={styles.root}>
			<div className={styles.mainContent}>
				<div className={styles.leftContainer}>
					<Logo />
					{children}
				</div>

				{showRightLayout && (
					<div className={styles.rightContainer}>
						<div className={styles.svgContainer}>
							<Icon type="venzaLanding" />
						</div>

						<div className={styles.contentContainer}>
							<h1 className={styles.heading}>
								{content.heading}
							</h1>
							<p className={styles.description}>
								{content.description}
							</p>
						</div>
					</div>
				)}
			</div>
			{showPortalBtn && <PortalButton />}
			<NewFooter isAdminLogin={showPortalBtn} />
		</div>
	);
}
